import React, { useEffect, useState } from "react";
import { DealsPageLayout } from "../../components/deals/dealsPageLayout/DealsPageLayout";
import { LawFirmCreate, Organization } from "../../api/generated-api";
import { configureAuthHeader, configureBaseUrl } from "../../api/axiosConfig";
import { connect } from "react-redux";
import { adminCreateLawFirm, adminGetLawFirms } from "../../api/admin/lawfirms";
import { Grid, Typography, useTheme } from "@mui/material";
import { toValidIdentifier } from "../../helpers/utilsTS";
import { Link } from "react-router-dom";
import { CreateOrganizationModal } from "../organization/CreateOrganizationModal";

const AdminLawFirmsPage = (props) => {
  const token = props.token;
  configureBaseUrl();
  configureAuthHeader(token);

  const theme = useTheme();

  const [lawFirms, setLawFirms] = useState<Organization[]>([]);

  const [isNewLawFirmModalOpen, setIsNewLawFirmModelOpen] =
    useState<boolean>(false);

  const [newLawFirm, setNewLawFirm] = useState<LawFirmCreate>({
    city: undefined,
    email: undefined,
    firstName: undefined,
    lastName: undefined,
    line: undefined,
    name: undefined,
    state: undefined,
    zip: undefined,
  });

  const fetchAndSetLawFirms = () => {
    adminGetLawFirms((fetchedOrganization) => {
      setLawFirms(fetchedOrganization);
    });
  };

  useEffect(() => {
    fetchAndSetLawFirms();
  }, [token]);

  return (
    <DealsPageLayout
      title={"Law Firms"}
      actionButtons={[
        {
          dataTestId: "super-admin-create-law-firm",
          label: "Create Law Firm",
          onClick: () => {
            setIsNewLawFirmModelOpen(true);
          },
        },
      ]}
    >
      {lawFirms.map((lawFirm) => {
        return (
          <Grid
            data-testid={toValidIdentifier(`law-firm-client-row`)}
            key={lawFirm.id}
            container
            sx={{
              padding: "20px",
              border: `1px solid ${theme.palette.tertiary.light}`,
              marginBottom: "20px",
            }}
          >
            <Grid item xs={12}>
              <Typography
                variant={"h3"}
                data-testid="client-name"
                component={Link}
                to={`/admin/organizations/${lawFirm.id}`}
              >
                {lawFirm.name}
              </Typography>
            </Grid>
          </Grid>
        );
      })}
      <CreateOrganizationModal
        isOpen={isNewLawFirmModalOpen}
        title={"New Law Firm"}
        contentText={
          "The Law Firm will be created, you will need to invite the user separately."
        }
        dataTestIdModifier={"new-law-firm"}
        isSaveButtonDisabled={false}
        onCancel={() => {
          setIsNewLawFirmModelOpen(false);
        }}
        onSave={() => {
          adminCreateLawFirm(newLawFirm, () => {
            fetchAndSetLawFirms();
          });
          setIsNewLawFirmModelOpen(false);
        }}
        onFieldChange={(event) => {
          setNewLawFirm({
            ...newLawFirm,
            [event.target.name]: event.target.value,
          });
        }}
        nameLabel={"Law Firm Name"}
      />
    </DealsPageLayout>
  );
};

const mapStateToProps = (state) => {
  const { token } = state.auth;
  return {
    token,
  };
};

export default connect(mapStateToProps)(AdminLawFirmsPage);
